import { render, staticRenderFns } from "./DeleteTagKeyDialog.vue?vue&type=template&id=3de811c8"
import script from "./DeleteTagKeyDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTagKeyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports